import { createStore, Store, useStore as baseUseStore } from 'vuex'
import { ServiceMeta } from '@/service-meta'
import { InjectionKey } from 'vue'

import { Configuration } from '@/configuration'
import axios from 'axios'

// define your typings for the store state
export interface State {
  serviceMeta: ServiceMeta;
  currentLog: Array<string>;
  previousLog: Array<string>;
  configuration: Configuration;
  token: string;
  webSocketJwt: string;
  webSocket: WebSocket | null;
}

// define injection key
export const key: InjectionKey<Store<State>> = Symbol('Vuex Store Key')

export default createStore<State>({
  state: {
    serviceMeta: {
      name: '',
      running: 0,
      wanted: 0,
      namespace: '',
      deployment: '',
      replicaSet: '',
      pod: '',
      podTimestamp: ''
    },
    currentLog: [],
    previousLog: [],
    configuration: {
      apiBase: '',
      apiEndpoint: '',
      wsBase: '',
      contactMail: '',
      logLimit: 0,
      footer: ''
    },
    token: '',
    webSocketJwt: '',
    webSocket: null
  },
  mutations: {
    updateServiceMeta (state: State, serviceMeta: ServiceMeta) {
      state.serviceMeta = serviceMeta
    },
    addCurrentLogLines (state: State, payload: { lines: Array<string>, limit: number }) {
      state.currentLog.push(...payload.lines)
      if (state.currentLog.length > payload.limit) {
        state.currentLog = state.currentLog.slice(-payload.limit)
      }
    },
    addPreviousLogLines (state: State, payload: { lines: Array<string>, limit: number }) {
      state.previousLog.push(...payload.lines)
      if (state.previousLog.length > payload.limit) {
        state.previousLog = state.previousLog.slice(-payload.limit)
      }
    },
    clearLogs (state: State) {
      state.currentLog = []
      state.previousLog = []
    },
    setToken (state: State, token: string) {
      state.token = token
    },
    setWebSocketJwt (state: State, jwToken: string) {
      state.webSocketJwt = jwToken
    },
    setWebSocket (state: State, webSocket: WebSocket) {
      state.webSocket = webSocket
    },
    setConfiguration (state: State, configuration: Configuration) {
      state.configuration = configuration
    }
  },
  actions: {
  },
  modules: {
  },
  strict: process.env.NODE_ENV !== 'production'
})

export function useStore (): Store<State> {
  return baseUseStore(key)
}
